import { render } from "./PayAsYouGo.vue?vue&type=template&id=524ee05c&ts=true"
import script from "./PayAsYouGo.vue?vue&type=script&lang=tsx"
export * from "./PayAsYouGo.vue?vue&type=script&lang=tsx"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__